import { heroBackgroundVideo, heroEntry } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { HeroChatDemo } from '@/components/HeroChatDemo';
import { HeroVideoBackground } from '@/components/HeroVideoBackground';
import { trackCtaClick, onWhatsAppAnchorClick } from '@/lib/tracking';
import './Hero.css';

export function Hero() {
  return (
    <section
      className={`hero${heroBackgroundVideo.enabled ? ' hero--video' : ''}`}
      id="inicio"
    >
      <HeroVideoBackground />
      <div className="container hero__grid">
        <ScrollReveal className="hero__copy">
          <span className="hero__eyebrow">{heroEntry.eyebrow}</span>
          <h1 className="hero__title">
            {heroEntry.headline}
            <span className="hero__title-highlight">{heroEntry.titleAccent}</span>
          </h1>
          <p className="hero__subtitle">{heroEntry.subtitle}</p>
          <div className="hero__stats" aria-label="Beneficios clave">
            {heroEntry.stats.map((stat) => (
              <div key={stat.value} className="hero__stat">
                {'href' in stat && stat.href ? (
                  <a
                    href={stat.href}
                    className="hero__stat-link"
                    onClick={() => trackCtaClick('hero', stat.value, stat.href)}
                  >
                    <strong>{stat.value}</strong>
                  </a>
                ) : (
                  <strong>{stat.value}</strong>
                )}
                {'label' in stat && stat.label ? <span>{stat.label}</span> : null}
              </div>
            ))}
          </div>
          <div className="hero__actions">
            <a
              href={heroEntry.ctaPrimaryHref}
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
              onClick={onWhatsAppAnchorClick('hero', heroEntry.ctaPrimary)}
            >
              {heroEntry.ctaPrimary}
            </a>
            <a
              href={heroEntry.ctaSecondaryHref}
              className="btn btn-secondary btn-secondary--entry"
              onClick={() =>
                trackCtaClick('hero', heroEntry.ctaSecondary, heroEntry.ctaSecondaryHref)
              }
            >
              {heroEntry.ctaSecondary}
            </a>
          </div>
        </ScrollReveal>

        <div className="hero__visual">
          <HeroChatDemo />
        </div>
      </div>
    </section>
  );
}
